const num = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

// Form state → settlement API body. All arithmetic stays on the server.
export function buildBody(f) {
  const body = { reason: f.reason.trim(), charges: [] };
  const newRent = num(f.newRent);
  const newDays = num(f.newDays);
  if (newRent !== null || newDays !== null) {
    body.rent = { new_rent: newRent, new_days: newDays, collection_mode: f.rentMode || null, payment_method: f.rentMethod || null };
  }
  if (f.collectionStatus) {
    body.collection_status = f.collectionStatus;
    body.collection_date = f.collectionDate || null;
  }
  body.charges = f.charges
    .filter((c) => Number(c.amount) > 0)
    .map((c) => ({ charge_type: c.charge_type, amount: Number(c.amount), description: c.description || "", collection_mode: c.collection_mode, payment_method: c.payment_method || null }));
  if (f.bondAction && f.bondAction !== "none") {
    body.bond = { refund_type: f.bondAction, refund_amount: num(f.bondRefund), deduction_amount: num(f.bondKeep), refund_method: f.bondMethod || null };
  }
  if (Number(f.rentRefund) > 0) body.rent_refund = { amount: Number(f.rentRefund), method: f.rentRefundMethod || null };
  body.existing = Object.entries(f.existing || {}).map(([id, o]) => ({ charge_id: id, action: o.action, collection_mode: o.mode, payment_method: o.method || null }));
  if (f.bondFix !== "" && f.bondFix !== undefined) body.bond_refund_fix = { recorded_refund: Number(f.bondFix) };
  if (Number(f.credit) > 0) body.credit = { amount: Number(f.credit), expiry_months: num(f.creditExpiry) };
  return body;
}

export const blankForm = () => ({
  reason: "", newRent: "", newDays: "", rentMode: "", rentMethod: "", collectionStatus: "", collectionDate: "",
  charges: [], bondAction: "none", bondRefund: "", bondKeep: "", bondMethod: "", rentRefund: "", rentRefundMethod: "",
  credit: "", creditExpiry: "", existing: {}, bondFix: "",
});
